export function tourCategoryListing() {
    $(function () {
        var type = $('.city-filters').data('type');
        $('.city-filters label').click(function () {
            var targetCity = $(this).find('input').data('target');
            window.location.replace(window.home + '/' + targetCity + '/' + type + '/');
        });

        $('.tourtype-filters label').click(function (e) {
            e.preventDefault();
            var clickedItem = $(this).children('input');
            if (clickedItem.prop("checked") === true) {
                clickedItem.prop("checked", false);
                var targetCity = $('.city-filters').find('input:checked').data('target');
                window.location.replace(window.home + '/' + targetCity + '/' + type);
            } else {
                clickedItem.prop("checked", true);
                var targetCity = $('.city-filters').find('input:checked').data('target');
                var target = $(this).find('input').data('target');
                window.location.replace(window.home + '/' + targetCity + '/' + type + '/' + target);
            }
        });

        $('.open-filter-box-button').click(function () {
            $('.filter-box').addClass('active');
        });

        $('.close-filterbox').click(function () {
            $('.filter-box').removeClass('active');
        });

        $('.reset-filterbox').click(function () {
            var targetCity = $('.city-filters').find('input:checked').data('target');
            window.location.replace(window.home + '/' + targetCity + '/' + type);
        });

        $('.language-filters input, .tag-filters input, .special-interest-filters input').change(function () {
            $('form.filter-form').submit();
        });

        var annoucement = $('.announcement-bar').height();
        var top_space = 78 + annoucement;  // $('.page-link-holder').height()

        var linkArr = [];
        var topArr = [];
        $('.anchor-link').each(function () {
            var link = $(this).attr('href');
            if ($(link).length) {
                linkArr.push(link);
                topArr.push($(link).offset().top - top_space);
            } else {
                $(this).parent().remove();
            }
        });

        var annoucement = $('.announcement-bar').height();
        var sticky = $('.page-links').offset().top;
        var timer;
        $(window).scroll(function () {
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(function () {
                if (window.pageYOffset > sticky) {
                    $('.page-links').addClass("sticky");
                } else {
                    $('.page-links').removeClass("sticky");
                }

                var active_section = '';
                for (var i = 0; i < topArr.length; i++) {
                    if (window.pageYOffset > topArr[i]) {
                        active_section = linkArr[i];
                    }
                }

                $('.page-link-holder ul li a').each(function () {
                    $(this).removeClass("active");
                    if ($(this).attr('href') == active_section) {
                        $(this).addClass('active');
                    }
                });

            }, 10);
        });

        $('.anchor-link').on('click', function (event) {
            event.preventDefault();
            var id = $(this).attr('href');
            var top = $(id).offset().top - annoucement - 88;
            $('html, body').animate({ scrollTop: top }, 500)
        });
    });

    if ($(window).width() < 667) {
        $('.single-info-holder h2').click(function () {
            $(this).parent().toggleClass('active');
        });
        if (bikeBoxLength > 3) {
            $('.prices-wrapper').addClass('activate-shadow');
        }
    }

    var bikeBoxLength = $('.bikes-slider .slide').length;
    if (bikeBoxLength > 6) {
        $('.bikes-slider').slick({
            speed: 500,
            slidesToShow: 6,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
            ]
        });
    } else {
        $('.bikes-slider-wrapper').addClass('static');
    }
    $('.bikes-slider-wrapper .arrow.left').click(function () {
        $('.bikes-slider').slick('slickPrev')
    });
    $('.bikes-slider-wrapper .arrow.right').click(function () {
        $('.bikes-slider').slick('slickNext')
    });

    $('.locations-slider').slick({
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    $('.locations-wrapper .prev').click(function () {
        $('.locations-slider').slick('slickPrev');
    });
    $('.locations-wrapper .next').click(function () {
        $('.locations-slider').slick('slickNext');
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/tourCategoryListing.js